<template lang="html">
  <div id="text-page">
    <div class="container med-container">
      <div class="col-12 col-s-title">
        <h1 class="title"><span>Contrato marco de prestación de servicios de telecomunicaciones</span></h1>
      </div>

      <div class="mt-2 body">
        <p class="text-center">
          De fecha 7 de diciembre de 2021 entre ALTÁN REDES, S.A.P.I. DE C.V. y BLACKFON MX, S.A. DE C.V
        </p>
        <br />

        <contrato-a></contrato-a>
        <contrato-b></contrato-b>
        <contrato-c></contrato-c>

      </div>

    </div>
  </div>
</template>

<script>
import ContratoA from './contrato-m-a.vue';
import ContratoB from './contrato-m-b.vue';
import ContratoC from './contrato-m-c.vue';
export default {
  components: {
    ContratoA,
    ContratoB,
    ContratoC,
  },
}
</script>
